const menu = require("../components/menu");
const resize = require("./resize");

exports.init = function($) {
  var CP = {
    debug: false,
    tallest: 0,
    init: function() {
      if (this.debug) {
        console.log('CP.init()'); // eslint-disable-line no-console
      }

      // init
      if (menu && menu.init) {
        menu.init($);
      }

      resize.init($);
      if ($('.cat-container .cat').length > 1) {
        $('.cat').each(function () {
          $(this).hover(function () {
            $(this).find('.circle-arrow').addClass('animated pulse');
          }, function () {
            $(this).find('.circle-arrow').removeClass('animated pulse');
          })
        });
      }
    },
    Bindings: function() {
      if (this.debug) {
        console.log('CP.Bindings()'); // eslint-disable-line no-console
      }

      // event listeners
    }
  };

  //are we good?
  if ($('body').length) {
    CP.init();
  }
};
